import 'datatables.net-dt/css/jquery.dataTables.css'
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table,Pager} from 'react-bootstrap';
import RaisedButton from 'material-ui/RaisedButton';
import swal from 'sweetalert';
import {Typeahead} from 'react-bootstrap-typeahead';
import Help from '../../generics/help';

const Config = require('../../../config');
const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

class Messages extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.onSave = this.onSave.bind(this);

		this.state = {
			sex:"all",
			states:[],
			state:"all",
			mpio:"all",
			blood_types:[],
			blood_type:"all",
			send_sms:false,
			send_email:false,
			message_email:"",
			message_sms:"",
			include_pdf:false,
			donation_types:[],
			donation_type:"all",

			mpios:[],
			mpioSelected:[{names:'TODOS'}],
	      	indice:-1,
	      	isLoading: false,

	      	listado:[],

	      	pagination:{},
	      	filterText:"",
	      	group:"all",
	      	rh:"all",

		}
	}

	componentDidMount(){
		fetch(Config.default.apiGateway.URL+'donation_type/actives',{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({donation_types:response});
			}
		});

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'lookups_level2?type=state_mx&option=parents',{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					states:response
				});
			}
		});

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_group_rh',{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					blood_types:response
				});
			}
		});

	}

	handleChange(e){
		if(e.target !== undefined){
			if(e.target.type === 'checkbox'){
				

				if(e.target.id === 'all_check'){
					this.state.listado.map((l)=>{
						l.check = e.target.checked ? true : false
					})
				}else if(e.target.id === 'include_pdf'){
					this.setState({include_pdf: e.target.checked ? true : false});
				}else{
					var id = parseInt(e.target.id);
					var index = this.state.listado.findIndex(obj => 
						obj.id === id
					);
					this.state.listado[index].check = e.target.checked ? true : false;
				}

				this.forceUpdate();

			}else{
				this.setState({
					[e.target.name]: e.target.value
				});

				if(e.target.name === 'state'){

					this.setState({
						mpio:e.target.value === 'all' ? 'all' : '', 
						mpioSelected:e.target.value === 'all' ? [{names:'TODOS'}] : []
					});
					if(e.target.value !== 'all'){
						this.getMpios(e.target.value);
					}
					
				}

				if(e.target.id === 'filterText'){
					if(e.target.value !== ""){
						this.filter(e.target.value);
					}else{
						this.paginator(this.state.listado);
					}
					

				}

				if(e.target.value !== ""){
					document.getElementById(e.target.id).classList.remove('error');
				}
			}
			
		}else{
			if(e.length > 0){
				this.setState({
					mpioSelected:e,
					mpio:e[0].key
				});
			}
		}	
	}

	getMpios(key){
		fetch(Config.default.apiGateway.URL+'lookups_level2?type='+key+'&option=parents',{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				for (var i = 0; i < response.length; i++) {
					response[i].names = response[i].value_name;
					response[i].id = i;
				};
				response.unshift({names:'TODOS', key:'all'});
				this.setState({
					mpios:response,
					mpio:'all',
					mpioSelected:[{names:'TODOS', key:'all'}]
				});
			}
		});
	}

	searching(e){
		e.preventDefault();
		if(this.validSearch()){
			//var group = this.state.blood_type === 'all' ? 'all' : this.state.blood_type.split(' ')[0];
			//var rh = this.state.blood_type === 'all' ? 'all' : this.state.blood_type.split(' ')[1];
			this.props.waiting.handleShow('Cargando...');

			fetch(Config.default.apiGateway.URL+'donors/?sex='+this.state.sex+
				'&donation_type='+this.state.donation_type+'&estate='+this.state.state+'&town='+this.state.mpio+
				'&group='+this.state.group+'&rh='+this.state.rh,{
				method: 'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					response.map((res)=>{
						res.check = false;
					});
					this.setState({
						listado:response
					})

					this.paginator(response);
				}
			});
		}
	}

	validSearch(){
		const fields = document.querySelector('.searching');
		const ctrls = fields.querySelectorAll('input,select');

		var is_valid = true;
		ctrls.forEach(function(ctrl, i){
			if(ctrl.value !== ""){
				if(ctrl.className.includes('error')){
					ctrl.classList.remove('error');
				}
			}else{
				
				if(!ctrl.className.includes('rbt-input-hint') && ctrl.className.length > 0){
					ctrl.classList.add('error');
					is_valid = false
				}		
				
			}
		})

		return is_valid;
	}

	onSave(){
		var sms = document.getElementById('send_sms').checked;
		var mail = document.getElementById('send_email').checked;
		var send = true;
		var error = '';
		this.setState({
			send_sms:sms,
			send_email:mail
		});


		setTimeout(()=>{			

			if(this.state.send_sms || this.state.send_email){
				

					var obj = {
						health_facilities_id: parseInt(sessionStorage.getItem('health_facilities_id')),
						send_mail: this.state.send_email,
						send_sms: this.state.send_sms,
						sms_text: this.state.message_sms,
						email_text:this.state.message_email,
						include_pdf:this.state.include_pdf,
						donor_id:[]
					}
			
					this.state.listado.map((l)=>{
						if(l.check){
							obj.donor_id.push(l.id);
						}
					});

					if(obj.donor_id.length === 0){
						send = false;
						error = 'Debe seleccionar al menos un elemento de la lista';
					}else if(this.state.send_sms || this.state.send_email){
						if(this.state.message_sms === "" && this.state.send_sms){
							send = false;
							error = 'El mensaje SMS no puede ir vacio';
						}

						if(this.state.message_email === "" && this.state.send_email){
							send = false;
							error = 'El mensaje de correo no puede ir vacio';
						}
					}

					if(send){
						this.props.waiting.handleShow('Guardando...');
						fetch(Config.default.apiGateway.URL+'aws/send', {
							method:'post',
							body:JSON.stringify(obj),
							headers: new Headers({
								'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
								'Accept'		: 'application/json',
								'Content-Type'	: 'application/json'
							})
						}).then(res => {
							this.props.waiting.handleClose();
							if(res.ok){
								return res.json();
							}else{
								res.text().then((msg)=>{
									swal('Erros', msg, 'error');
								});
							}
						}).then(response => {
							if(response !== undefined){

								this.setState({
									sex:"all",
									state:"all",
									mpio:"all",
									blood_types:[],
									blood_type:"all",
									send_sms:false,
									send_email:false,
									message_email:"",
									message_sms:"",
									include_pdf:false,
									donation_types:[],
									donation_type:"all",

									mpios:[],
									mpioSelected:[{names:'TODOS'}],
							      	indice:-1,
							      	isLoading: false,

							      	listado:[],

							      	pagination:{},
							      	filterText:"",
								});

								document.getElementById('send_sms').checked = false;
								document.getElementById('send_email').checked = false;

								swal('Correcto', 'El registro se guardo correctamente', 'success');
							}
						});
					}else{
						swal('Error', error, 'error');
					}

				
			}else{
				swal('Error', 'Debe seleccionar alguna opción de envío (SMS, EMAIL)', 'error');
			}
		}, 200);		
	}

	paginator(item, page, per_page){

	    var page        = page || 1,
	    per_page        = per_page || 100000000000,
	    offset          = (page - 1) * per_page,
	    paginatedItems  = item.slice(offset).slice(0, per_page),
	    total_pages     = Math.ceil(item.length / per_page);
	    var pagination  = {
	     	page        : page,
	      	per_page    : per_page,
	      	pre_page    : page - 1 ? page - 1 : null,
	      	next_page   : (total_pages > page) ? page + 1 : null,
	      	total       : item.length,
	      	total_pages : total_pages,
	      	data        : paginatedItems
	    }

  		this.setState({
    		pagination: pagination
  		})  
  	}

  	filter(value){
  		var list = [];
  		this.state.listado.map((l)=>{
			if(l.name !== null){
				if(l.name.indexOf(value.toUpperCase()) !== -1){
					list.push(l);
				}
  			}
  			if(l.sex !== null){
  			 	if(l.sex.indexOf(value.toUpperCase()) !== -1){
  					list.push(l);
  				}
  			}
  			if(l.estado !== null){
  				if(l.estado.indexOf(value.toUpperCase()) !== -1){
	  				list.push(l);
	  			}
  			}
  			if(l.municipio !== null){
  				if(l.municipio.indexOf(value.toUpperCase()) !== -1){
	  				list.push(l);
	  			}
  			}
  			if(l.age !== null){
  				if(l.age.toString().indexOf(value.toUpperCase()) !== -1){
	  				list.push(l);
	  			}
  			}
  			if(l.grupo_rh !== null){
  				if(l.grupo_rh.indexOf(value.toUpperCase()) !== -1){
	  				list.push(l);
	  			}
  			}
  		});

  		this.paginator(list);
  	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{sessionStorage.getItem('health_facilities_name')} ->
					Promoción ->
					Mensajes
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_promotion"} 
	                submenu={"help_messages"}  />

				<div className="col-xs-12">
					<fieldset className="col-xs-12 form-group searching">
						<legend>Búsqueda</legend>
						<div className="col-xs-12 col-sm-1">
							<span className="span-min">Sexo</span>
							
							<select className="form-control" name="sex" id="sex" value={this.state.sex}
								onChange={this.handleChange}>
								<option value="">Seleccione...</option>
								<option value="all">TODOS</option>
								<option value="HOMBRE">HOMBRE</option>
								<option value="MUJER">MUJER</option>
							</select>
						</div>

						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Tipo de Donantes</span>
							<select className="form-control" name="donation_type" id="donation_type" value={this.state.donation_type}
								onChange={this.handleChange}>
								<option value="">Seleccione...</option>
								<option value="all">TODOS</option>
								{this.state.donation_types.map((don, i)=>(
									<option key={i} value={don.donation_type.id}>
										{don.lookup_value}
									</option>
								))}
							</select>
						</div>
						<div className="col-xs-12 col-sm-3">
							<span className="span-min">Estado</span>
							<select className="form-control" name="state" id="state" value={this.state.state}
								onChange={this.handleChange}>
								<option value="">Seleccione...</option>
								<option value="all">TODOS</option>
								{this.state.states.map((s, i)=>(
	        						<option key={i} value={s.key}>{s.value_name}</option>
	        					))}
							</select>
						</div>
						<div className="col-xs-12 col-sm-3">
							<span className="span-min">Municipio</span>
							<Typeahead
					          	labelKey={(option) => `${option.names}`}
					          	minLength={0}
					          	name="mpio"
					          	id="mpio" onKeyPress={(e) => this.props.validate(e)}
					          	inputProps={{
				          			name:"MUNICIPIO",
				          			id:"MUNICIPIO",
				          			autoComplete:'off',
				          			required: true,
				          	  	}}
				          	  	className="input_data_donor"
					          	options={this.state.mpios}
					          	onChange={this.handleChange}
					          	selected={this.state.mpioSelected}
					          	ref="_handleSearch"
					          	useCache={false}
					          	isLoading={this.state.isLoading}
					          	delay={600}
					          	paginationText="Mostrar mas resultados..."
					        />
							
						</div>
						<div className="col-xs-12 col-sm-1">
							<span className="span-min">Grupo</span>
							<select className="form-control" name="group" id="group" value={this.state.group}
								onChange={this.handleChange}>
								<option value="">Seleccione...</option>
								<option value="all">TODOS</option>
								{this.state.blood_types.map((s, i)=>(
	        						i % 2 === 0 ? 
					                	<option key={i}  value={s.key_group} >
					                  		{s.key_group} 
					                	</option>
					                :null
	        					))}
							</select>
						</div>
						<div className="col-xs-12 col-sm-1">
							<span className="span-min">RH</span>
							<select className="form-control" name="rh" id="rh" value={this.state.rh}
								onChange={this.handleChange}>
								<option value="">Seleccione...</option>
								<option value="all">TODOS</option>
								<option value="POSITIVO">POSITIVO</option>
								<option value="NEGATIVO">NEGATIVO</option>
							</select>
						</div>
						<div className="col-xs-12 col-sm-1">
							<button type="button" className="btn btn-info"  
								onClick={this.searching}
								style={{fontSize:"14px", marginTop:'10px'}}>
								Buscar
							</button>
						</div>
					</fieldset>
					<hr style={{width:'100%'}} />
					<div className="col-xs-6 form-group">
						<div className="col-xs-12">
							<div className="col-xs-6">
								<input type="checkbox" name="send_email" id="send_email" />
								<span className="span-min" style={{marginLeft:'5px'}}>Enviar Correo</span>
							
								<input type="checkbox" name="include_pdf" id="include_pdf" value={this.state.include_pdf} 
									style={{marginLeft:'10px'}}
									checked={this.state.include_pdf} onChange={this.handleChange} />
								<span className="span-min" style={{marginLeft:'5px'}}>Adjuntar plantilla PDF</span>
							</div>
						</div>
						<div className="col-xs-12">
							<span className="span-min" style={{marginLeft:'5px'}}>Mensaje Email</span>
							<textarea className="form-control" name="message_email" id="message_email" value={this.state.message_email} 
								onChange={this.handleChange} />
						</div>
					</div>
					<div className="col-xs-6 form-group">
						<div className="col-xs-12">
							<div className="col-xs-6">
								<input type="checkbox" name="send_sms" id="send_sms" />
								<span className="span-min" style={{marginLeft:'5px'}}>Enviar SMS</span>
							</div>
						</div>
						<div className="col-xs-12">
							<span className="span-min" style={{marginLeft:'5px'}}>Mensaje SMS</span>
							<textarea className="form-control" name="message_sms" id="message_sms" value={this.state.message_sms} 
								onChange={this.handleChange} />
						</div>
					</div>
					
					<hr style={{width:'100%'}} />
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 form-group">
							<div className="col-xs-12 col-sm-3" style={{padding:'0'}}>
								<input className="form-control" placeholder="Buscar" name="filterText"
									id="filterText" value={this.state.filterText} onChange={this.handleChange} />
							</div>
						</div>

						<div className="col-xs-12" style={{textAlign:'center'}}>
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.submit')} 
			        			primary={true}  style={{margin:12}} onClick={this.onSave} />
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} 
			        			primary={true} style={{margin:12}} />
			        	</div>

						<div className="col-xs-12 form-group">
							<Table>
								<thead>
									<tr>
										<th>
											<input type="checkbox" name="all_check" id="all_check" onChange={this.handleChange}  />
										</th>
										<th>Nombre</th>
										<th>Sexo</th>
										<th>Estado</th>
										<th>Municipio</th>
										<th>Edad</th>
										<th>Grupo & RH</th>
									</tr>
								</thead>
								<tbody>
									{this.state.pagination.data !== undefined ?
										this.state.pagination.data.map((l, i)=>(
										//this.state.listado.map((l, i)=>(
											<tr key={i}>
												<td>
													<input type="checkbox" id={l.id} name={l.id} value={l.check}
														checked={l.check} onChange={this.handleChange}  />
												</td>
												<td>{l.name}</td>
												<td>{l.sex}</td>
												<td>{l.estado}</td>
												<td>{l.municipio}</td>
												<td>{l.age}</td>
												<td>{l.grupo_rh}</td>
											</tr>
										))
									:null}
									
								</tbody>
							</Table>
						</div>

						{/*<div className="col-xs-12">
							<Pager>                       
	                            <Pager.Item disabled={this.state.pagination.pre_page === null}
	                              	onClick={function(){this.paginator(this.state.listado, this.state.pagination.pre_page)}.bind(this)} 
	                              	href="#">
	                              	Anterior
	                           </Pager.Item>
		                           {' Página '+
		                           (this.state.pagination.page === undefined ? 0 : this.state.pagination.page)+
		                           ' de '+
		                           (this.state.pagination.total_pages === undefined ? 0 : this.state.pagination.total_pages)+' '}
	                           <Pager.Item disabled={this.state.pagination.next_page === null} 
	                              	onClick={function(){this.paginator(this.state.listado, this.state.pagination.next_page)}.bind(this)} 
	                             	href="#">Siguiente
	                            </Pager.Item>
	                        </Pager>
						</div>

						<div className="col-xs-12" style={{textAlign:'center'}}>
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.submit')} 
			        			primary={true}  style={{margin:12}} onClick={this.onSave} />
			        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} 
			        			primary={true} style={{margin:12}} />
			        	</div>*/}
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations')(Messages);